import { CheckCircleTwoTone, CloseCircleOutlined } from '@ant-design/icons';
import { Badge, Card, Tag } from 'antd';
import { message } from '@/components/Message';
import BigNumber from 'bignumber.js';
import React, { useEffect } from 'react';
import { Coupon, CouponUserStatus, CouponUserStatusDescMap } from '@/models/coupon';
import styles from './style.less';

type Props = {
  price?: BigNumber;
  coupon: Coupon;
  selected?: boolean;
  onInvalidSelected?: (reason: string) => void;
  onSelectedChange?: (selected: boolean, coupon: Coupon) => void;
};

const CouponCom: React.FC<Props> = ({
  price,
  coupon,
  selected = false,
  onSelectedChange = () => {},
  onInvalidSelected = () => {},
}: Props) => {
  let couponInfo;

  if (coupon.couponType === 1) {
    couponInfo = (
      <div className={styles.content}>
        <div className={styles.discount}>
          <div className={styles.num}>{coupon.discount / 10}</div>折
        </div>
        <div className={styles.min}>
          满<b>{coupon.min}</b>元可用
        </div>
        <div className={styles.desc}>{coupon.desc}</div>
      </div>
    );
  } else if (coupon.couponType === 2) {
    couponInfo = (
      <div className={styles.content}>
        <div className={styles.discount}>
          <div className={styles.yen}>&yen;</div>
          <div className={styles.num}>{coupon.discount}</div>
        </div>
        <div className={styles.min}>
          满<b>{coupon.min}</b>元可用
        </div>
        <div className={styles.desc}>{coupon.desc}</div>
      </div>
    );
  }

  let reason = '';
  const minValid = price === undefined ? true : price.comparedTo(coupon.min) > 0;

  if (coupon.status !== CouponUserStatus.STATUS_USABLE) {
    reason = CouponUserStatusDescMap[coupon.status];
  }

  if (!minValid) {
    reason = '商品总额不足';
  }

  const available = coupon.available && minValid;

  useEffect(() => {
    if (!available && selected) {
      // 当可用状态变化时，如果不可用，取消勾选
      onSelectedChange(false, coupon);
      message.warning(`结算条件变更，优惠券已取消勾选，请注意`);
    }
  }, [price, selected]);

  return (
    <div className={styles.container}>
      <Badge.Ribbon
        key={`${available}-${coupon.id}`}
        color={available ? 'processing' : '#999'}
        text={
          <div style={{ maxWidth: '100%', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {coupon.name}
          </div>
        }
        placement={'start'}>
        <Card
          styles={{ body: { paddingBottom: 7 } }}
          size={'small'}
          style={selected ? { borderColor: `rgba(82, 196, 26, .7)` } : {}}
          onClick={() => {
            if (!selected) {
              if (!available) {
                onInvalidSelected(reason);
                return;
              }
            }
            onSelectedChange(!selected, coupon);
          }}>
          {couponInfo}
          <div className={styles.invalidTip}>
            {!available ? (
              <Tag icon={<CloseCircleOutlined />} color="error">
                {reason}
              </Tag>
            ) : null}
          </div>
        </Card>
      </Badge.Ribbon>
      {selected && <CheckCircleTwoTone twoToneColor="#52c41a" className={styles.selected} />}
    </div>
  );
};

export default CouponCom;
